export default "__VITE_ASSET__B_pKw7wR__"